var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "el-form",
        {
          ref: "requireVoucherRef",
          attrs: { model: _vm.deviceRequireVoucher, rules: _vm.checkVoucher }
        },
        [
          _c("div", { staticClass: "simple-form flex col-2" }, [
            !_vm.isBatchFalg
              ? _c("div", { staticClass: "form-group center" }, [
                  _c("div", { staticClass: "form-label" }, [
                    _c("label", { staticClass: "required" }, [
                      _vm._v("购置部门")
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "form-value" },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { prop: "requireComName" } },
                        [
                          _c("el-input", {
                            staticClass: "width-1-5x bottom-line",
                            attrs: { disabled: "", type: "text" },
                            model: {
                              value: _vm.deviceRequireVoucher.requireComName,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.deviceRequireVoucher,
                                  "requireComName",
                                  $$v
                                )
                              },
                              expression: "deviceRequireVoucher.requireComName"
                            }
                          }),
                          _vm._v(" "),
                          _vm.id == null
                            ? _c("div", {
                                staticClass:
                                  "form-tips icon iconfont icon-chazhaobiaodanliebiao relation-icon",
                                attrs: { title: "选择" },
                                on: {
                                  click: function($event) {
                                    _vm.selectRequireCom()
                                  }
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            !_vm.isBatchFalg
              ? _c("div", { staticClass: "form-group center" }, [
                  _c("div", { staticClass: "form-label" }, [
                    _c("label", { staticClass: "required" }, [
                      _vm._v("购置公司")
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-value" }, [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.deviceRequireVoucher.requireRealComName || ""
                        )
                      )
                    ])
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "form-group center" }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", {}, [_vm._v("经办人")])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-value" }, [
                _c("span", [
                  _vm._v(_vm._s(_vm.deviceRequireVoucher.applicantName))
                ])
              ])
            ]),
            _vm._v(" "),
            _vm.isBatchFalg
              ? _c("div", { staticClass: "form-group center" }, [
                  _c("div", { staticClass: "form-label" }, [
                    _c("label", { staticClass: "required" }, [
                      _vm._v("已外部审核")
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "form-value width-1-5x" },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.deviceRequireVoucher.outAuditFlag,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.deviceRequireVoucher,
                                "outAuditFlag",
                                $$v
                              )
                            },
                            expression: "deviceRequireVoucher.outAuditFlag"
                          }
                        },
                        [
                          _c("el-radio", { attrs: { label: true } }, [
                            _vm._v("是")
                          ]),
                          _vm._v(" "),
                          _c("el-radio", { attrs: { label: false } }, [
                            _vm._v("否")
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.isBatchFalg
              ? _c("div", { staticClass: "form-group center" }, [
                  _c("div", { staticClass: "form-label" }, [
                    _c(
                      "label",
                      {
                        class: _vm.deviceRequireVoucher.outAuditFlag
                          ? "required"
                          : ""
                      },
                      [_vm._v("审核单号")]
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "form-value width-1-5x" },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { prop: "auditPoofNo" } },
                        [
                          _c("el-input", {
                            attrs: { type: "text" },
                            model: {
                              value: _vm.deviceRequireVoucher.auditPoofNo,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.deviceRequireVoucher,
                                  "auditPoofNo",
                                  $$v
                                )
                              },
                              expression: "deviceRequireVoucher.auditPoofNo"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "form-group center" }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", { staticClass: "required" }, [
                  _vm._v("单独采购组装件")
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-value width-2x" },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "onlyForAsmblAcc" } },
                    [
                      _c("el-switch", {
                        attrs: { "active-color": "#13ce66" },
                        model: {
                          value: _vm.deviceRequireVoucher.onlyForAsmblAcc,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.deviceRequireVoucher,
                              "onlyForAsmblAcc",
                              $$v
                            )
                          },
                          expression: "deviceRequireVoucher.onlyForAsmblAcc"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group center" }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", { staticClass: "required" }, [_vm._v("标题")])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-value width-2x" },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "title" } },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "text",
                          placeholder:
                            "例如：XXX店（店号+店名）申请购置XX类设备"
                        },
                        model: {
                          value: _vm.deviceRequireVoucher.title,
                          callback: function($$v) {
                            _vm.$set(_vm.deviceRequireVoucher, "title", $$v)
                          },
                          expression: "deviceRequireVoucher.title"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group center" }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", { staticClass: "required" }, [_vm._v("采购需求")])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-value" },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "desc" } },
                    [
                      _c("el-input", {
                        staticClass: "textarea-value",
                        attrs: {
                          placeholder:
                            "请填写设备投入产出分析说明、资产购置描述和资产描述",
                          type: "textarea",
                          rows: 3,
                          resize: "both"
                        },
                        model: {
                          value: _vm.deviceRequireVoucher.desc,
                          callback: function($$v) {
                            _vm.$set(_vm.deviceRequireVoucher, "desc", $$v)
                          },
                          expression: "deviceRequireVoucher.desc"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ])
          ]),
          _vm._v(" "),
          _vm.isBatchFalg
            ? [
                _c("swb-create-require-item-for-batch", {
                  ref: "swb_create_require_item_for_batch",
                  attrs: {
                    id: _vm.id,
                    reloadItem: _vm.reloadItem,
                    onlyForAsmblAcc: _vm.deviceRequireVoucher.onlyForAsmblAcc,
                    audoAuditorFlag: _vm.deviceRequireVoucher.audoAuditorFlag,
                    lowCostFlag: _vm.lowCostFlag
                  }
                })
              ]
            : [
                _c("swb-create-require-item", {
                  ref: "swb_create_require_item",
                  attrs: {
                    id: _vm.id,
                    reloadItem: _vm.reloadItem,
                    requireRealComId: _vm.deviceRequireVoucher.requireRealComId,
                    onlyForAsmblAcc: _vm.deviceRequireVoucher.onlyForAsmblAcc,
                    bizFormId: _vm.bizFormId,
                    bizAreaId: _vm.bizAreaId,
                    audoAuditorFlag: _vm.deviceRequireVoucher.audoAuditorFlag,
                    lowCostFlag: _vm.lowCostFlag
                  }
                })
              ]
        ],
        2
      ),
      _vm._v(" "),
      _c("div", { staticClass: "form-toolbar" }, [
        _c(
          "button",
          {
            staticClass: "swb-btn swb-btn-small swb-btn-primary",
            on: { click: _vm.goBack }
          },
          [_vm._v("返回")]
        ),
        _vm._v(" "),
        _vm.showApplyBtn
          ? _c(
              "button",
              {
                staticClass: "swb-btn swb-btn-small",
                on: {
                  click: function($event) {
                    _vm.saveDeviceRequireVocher(true)
                  }
                }
              },
              [_vm._v("申请")]
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "swb-btn swb-btn-small",
            on: {
              click: function($event) {
                _vm.saveDeviceRequireVocher(false)
              }
            }
          },
          [_vm._v("保存")]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed" }, [
      _c("span", [_vm._v("请购方")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2e97e566", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e97e566","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/retailer/DeviceRequireVocherSave.vue
// module id = 2908
// module chunks = 0